import { Injectable } from "@angular/core";
import { CommonApiService } from "./common-api.service";
import { APIURL } from "../global/constant";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private commonApiService: CommonApiService) {}

  onLoginWithMagicLink(payload: any) {
    return this.commonApiService.post(APIURL.loginWithMagicLink, payload);
  }

  onLoginWithPassword(payload: any) {
    return this.commonApiService.post(APIURL.loginWithPassword, payload);
  }

  onVerifyMagicLink(payload: any) {
    return this.commonApiService.post(APIURL.verifyMagicLink, payload);
  }

  onSendLoginOTP(payload: any) {
    return this.commonApiService.post(APIURL.sendLoginOTP, payload);
  }

  onVerifyLoginOTP(payload: any) {
    return this.commonApiService.post(APIURL.verifyLoginOTP, payload);
  }

  onUserOnboarding(payload: any) {
    return this.commonApiService.post(APIURL.UserOnboarding, payload);
  }
}
